import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Modal from '../../components/Modal/Modal';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField'
import FormLabel from '@mui/material/FormLabel';
import { Card, CardContent, Checkbox, FormHelperText, IconButton, Typography } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Link, useNavigate } from 'react-router-dom';
import styles from './FormularioPeticao.module.css';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { styled } from '@mui/material/styles';
import { telefoneMascara, telefoneSemMascara, cpfMascara, cpfSemMascara } from '../../util/mascaras';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import Head from '../../helper/Head';
import formularioPeticao from './service/formularioPeticao.service';
import { ClipboardText } from "@phosphor-icons/react";
import copy from "copy-to-clipboard";
import Toast from '../../components/Toast/Toast';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { env } from '../../../env/env';
import ProgressoCircular from '../../components/ProgressoCircular/ProgressoCircular';
import { useTranslation } from 'react-i18next';


const urlBack: string = (env.baseURL as string);

export default function FormularioPeticao() {
   const { register, handleSubmit, watch, setValue, clearErrors, setError, formState: { errors } } = useForm();
   const { t } = useTranslation();

   const [openModal, setOpenModal] = useState(false);
   const [errorMsg, setErrorMsg] = useState(false);
   const [isDisabled, setIsDisabled] = useState(false);


   const [estadoUsuarioList, setEstadoUsuarioList] = useState([] as any);
   const [estadoUsuario, setEstadoUsuario] = useState('');
   const [cidadeUsuarioList, setCidadeUsuarioList] = useState([] as any);
   const [cidadeUsuario, setCidadeUsuario] = useState('');

   const [estadoMembroList, setEstadoMembroList] = useState([] as any);
   const [estadoMembro, setEstadoMembro] = useState('');

   const [estadoOcorrenciaList, setEstadoOcorrenciaList] = useState([] as any);
   const [estadoOcorrencia, setEstadoOcorrencia] = useState('');
   const [cidadeOcorrenciaList, setCidadeOcorrenciaList] = useState([] as any);
   const [cidadeOcorrencia, setCidadeOcorrencia] = useState('');

   const [grupoTrabalhoList, setGrupoTrabalhoList] = useState([] as any);
   const [grupoTrabalhoOutros, setGrupoTrabalhoOutros] = useState(false);

   const [registroDenuncia, setRegistroDenuncia] = useState('');
   const [toastMessage, setToastMessage] = useState('');
   const [toastIcon, setToastIcon] = useState('');
   const [isToast, setIsToast] = useState(false);

   const [selectedFiles, setSelectedFiles] = useState<any[]>([]);
   const [isOpenProgressoCircular, setIsOpenProgressoCircular] = useState(false)

   const [hasOtherGenre, setHasOtherGenre] = useState(false);


   const anoAtual = new Date().getFullYear();

   const navigate = useNavigate();

   const [fatoLength, setFatoLength] = useState(0);
   const [pedidoLength, setPedidoLength] = useState(0);

   const [isAvisoOpen, setIsAvisoOpen] = useState(true);
   const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

   const handleCloseAviso = () => {
     setIsAvisoOpen(false);
   };

   const handleCheckboxChange = (e: any) => {
      setIsCheckboxChecked(e.target.checked);
   };

   useEffect(() => {
      fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
         .then((response) => response.json())
         .then((data) => setEstadoUsuarioList(data));
   }, []);

   useEffect(() => {
      if (!!estadoUsuario) {
         fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estadoUsuario}/municipios?orderBy=nome`)
            .then((response) => response.json())
            .then((data) => setCidadeUsuarioList(data));
      }
   }, [estadoUsuario]);

   useEffect(() => {
      fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
         .then((response) => response.json())
         .then((data) => setEstadoOcorrenciaList(data));
   }, []);

   useEffect(() => {
      if (!!estadoOcorrencia) {
         fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estadoOcorrencia}/municipios?orderBy=nome`)
            .then((response) => response.json())
            .then((data) => setCidadeOcorrenciaList(data));
      }
   }, [estadoOcorrencia]);

   useEffect(() => {      
         fetch('https://servicodados.ibge.gov.br/api/v1/localidades/paises?orderBy=nome')
         .then((response) => response.json())
         .then((data) => setEstadoMembroList(data));      
    }, []);

    useEffect(() => {
      const brasilEstaNaLista = estadoMembroList.some((option: { nome: string }) => option.nome === 'Brasil');
    
      if (brasilEstaNaLista && !estadoMembro) {
        setEstadoMembro('Brasil');
      }

      if (estadoMembro !== 'Brasil') {
         setEstadoUsuario('');
         setCidadeUsuario('');
      }

    }, [estadoMembroList, estadoMembro]);

   useEffect(() => {
      const images = selectedFiles;

      images.map(file => {
         if (file.sizeInMb > 10) {
            setErrorMsg(true);

         }
         else {
            setErrorMsg(false);
         }
      });

      if (!images.length) {
         setErrorMsg(false);
      }
      else if (images.length == 10) {
         setIsDisabled(true);
      }
      else if (images.length > 10) {
         setSelectedFiles([]);
         setToastMessage('O número máximo de arquivos é 10!');
         setToastIcon('error');
         setIsToast(true);
         setTimeout(() => {
            setIsToast(false);
         }, 100)
      }
      else {
         setIsDisabled(false);
      }
   }, [selectedFiles]);

   useEffect(() => {
      (async () => {
         const data = await formularioPeticao.getGrupoTrabalho();
         setGrupoTrabalhoList(data);
      })()
   }, []);

   function saveSelectedFiles(e: any) {
      const files = e.target.files;
      const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

      const filesValidate = [...files].filter(file => allowedTypes.includes(file.type));

      filesValidate.map(file => {
         file.sizeInMb = file.size / 1000000;
      });

      setSelectedFiles([...selectedFiles, ...filesValidate]);
   }

   function removeSelectedFile(index: any) {
      const arrayFiles = selectedFiles;

      arrayFiles.splice(index, 1);
      setSelectedFiles([...arrayFiles]);
   }

   const handleChangeEstadoUsuario = (event: SelectChangeEvent) => {
      clearErrors('estadoUsuario');
      setEstadoUsuario(event.target.value);

      estadoUsuarioList.forEach((e: any) => {
         if (e.id == event.target.value)
            setValue('estadoUsuario', e.nome);
      });
   };

   const handleChangeCidadeUsuario = (event: SelectChangeEvent) => {
      clearErrors('cidadeUsuario');
      setCidadeUsuario(event.target.value);

      cidadeUsuarioList.forEach((e: any) => {
         if (e.id == event.target.value)
            setValue('cidadeUsuario', e.nome);
      });
   };

   const handleChangeEstadoOcorrencia = (event: SelectChangeEvent) => {
      clearErrors('estadoOcorrencia');
      setEstadoOcorrencia(event.target.value);

      estadoOcorrenciaList.forEach((e: any) => {
         if (e.id == event.target.value)
            setValue('estadoOcorrencia', e.nome);
      });
   };

   const handleChangeCidadeOcorrencia = (event: SelectChangeEvent) => {
      clearErrors('cidadeOcorrencia');
      setCidadeOcorrencia(event.target.value);

      cidadeOcorrenciaList.forEach((e: any) => {
         if (e.id == event.target.value)
            setValue('cidadeOcorrencia', e.nome);
      });
   };

   const handleChangeEstadoMembro = (event: SelectChangeEvent) => {
      clearErrors('estadoMembro');
      setEstadoMembro(event.target.value);

      estadoMembroList.forEach((e: any) => {
         if (e.nome == event.target.value) {
            setValue('estadoMembro', e.nome);
            setIsDisabled(e.nome !== 'Brasil');
         }
      });
   };

   const handleCpfMascara = (e: any) => {
      setValue('cpf', cpfMascara(e.target.value))
   }

   const onSubmit = async (data: any) => {
      if(data.genero == 'Outros') {
         data.genero = data.outroGenero;
         delete data.outroGenero;
         console.log(data);
      }

      if (data.estadoMembro === undefined || data.estadoMembro === '' || data.estadoMembro === null) {
         data.estadoMembro = 'Brasil';
       }

      setIsOpenProgressoCircular(true);


      if (!data.grupoTrabalho) data.grupoTrabalho = [];

      if (errorMsg) {
         setIsOpenProgressoCircular(false);
         return;
      }

      data.telefone = telefoneSemMascara(data.telefone)
      //data.cpf = cpfSemMascara(data.cpf) //aqui

      const resp = await formularioPeticao.createFormularioPeticao(data);

      if (resp.registroDenuncia) {
         setRegistroDenuncia(resp.registroDenuncia);

         const formData = new FormData();
         formData.append('pathArquivosPeticao', resp.registroDenuncia.replace('/', '-'));

         for (let i = 0; i < selectedFiles.length; i++) {
            formData.append(`file[${i}]`, selectedFiles[i]);
         }

         const res = await fetch(urlBack + `uploadFiles`, {
            method: "POST",
            body: formData,
         });

         setIsOpenProgressoCircular(false);

         setOpenModal(true);
      } else if (resp?.error?.erro) {
         setIsOpenProgressoCircular(false);
      } else if (resp.error) {
         setToastMessage(resp.message);
         setIsToast(true);
         console.error(resp.message)
      }
   }

   const copyToClipboard = (e: any) => {
      copy(registroDenuncia);
      setToastMessage('Número do Registro da Denúncia Copiado!');
      setToastIcon('success');
      setIsToast(true)

      setTimeout(() => {
         setIsToast(false)
      }, 3000)
   }

   const handleTelefoneMascara = (e: any) => {
      setValue(e.target.name, telefoneMascara(e.target.value));
   }

   const handleCheckBox = (e: any) => {
      const nome = e.target.value.split(',');

      if (nome[1] == 'Outros' && e.target.checked) {
         setGrupoTrabalhoOutros(true)
      }
      else if (nome[1] == 'Outros' && !e.target.checked) {
         setGrupoTrabalhoOutros(false)
         setValue('grupoTrabalhoOutros', '');
      }
      clearErrors('grupoTrabalho');
   }

   const handleVerificaData = (e: any) => {
      const dataAnoInserida = e.target.value.split('-')[0];

      if (dataAnoInserida < anoAtual) {
         setError('dataViolacao', { message: 'Insira uma data deste ano!' });
         setValue('dataViolacao', '');
      } else {
         clearErrors('dataViolacao')
      }
   }

   const handleGenero = (e: any) => {
      setValue('genero', e.target.value)
      if (e.target.value === 'Outros') {
         setHasOtherGenre(true);
      } else {
         setHasOtherGenre(false);
         setValue('outroGenero', '');
      }
   }

   const textoRegistroDenuncia = `
   Anote o registro da petição para poder fazer o acompanhamento: <b>${registroDenuncia}</b> 
`;

   return (
      <section className="background-section background-full">

         {isAvisoOpen && (
         <div className={styles.avisoSuspenso}>
            <div className={styles.avisoSuspensoBox}>
               <div className={styles.avisoSuspensoLogo}>
                  <img src="assets/imagens/icone_dpu.png" height={40} width={40}/>
               </div>
               <div className={styles.avisoSuspensoButtonContainer}>
                  <IconButton onClick={handleCloseAviso} className={styles.avisoSuspensoButton}>
                     <CloseIcon />
                  </IconButton>
               </div>
               <p><span className={styles.missaDpu}>{t('tituloMissaoDPU')}</span> {t('textoMissaoDPU')}</p>
            </div>
         </div>
         )}

         <Toast open={isToast} icon={toastIcon} mensagem={toastMessage} timer={3000} />

         <Head title=" | Abrir petição" />
         <div className={`animeRight container`}>
            <div className={styles.sectionTitle}>
               <h1 className={styles.title}>
                  {t('tituloFormularioParte1')}
                  <br/>
                  {t('tituloFormularioParte2')}
               </h1>
               <h2 className={styles.subtitle}></h2>
            </div>
            <div className={styles.formContainer}>
               <Card>
                  <CardContent>
                     <Typography>
                        <h1 className={styles.formWelcome}>
                           {t('textoBemVindo')}
                        </h1>
                        <span className={styles.formDescription}>
                           {t('textoInformacao')}
                        </span>
                     </Typography>

                     <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
                        
                        <div className={styles.grid}>
                           <TextField
                              {...register('nome', { required: false })}
                              label={t('nome')}
                              variant="outlined"
                              type='text'
                              error={errors.nome ? true : false}
                           //helperText={errors.nomeRequerente && 'Campo Nome esta vazio!'}
                           />
                           <TextField
                              {...register('documentoPessoal', { required: false })} //aqui
                              label={t('documentoPessoal')}
                              variant="outlined"
                              type='text'
                              // value={cpf}
                              //onChange={handleCpfMascara}
                              // onChange={(e: any) => setValue('cpf', cpfMascara(e.target.value))}
                              error={errors.documentoPessoal ? true : false} //aqui
                              inputProps={{ maxLength: 14 }}
                           //helperText={errors.cpf && 'Campo CPF esta vazio!'}
                           />

                        </div>

                        <div className={styles.grid}>

                           <TextField
                              {...register('nomeSocial', { required: false })}
                              label={t('nomeSocial')}
                              variant="outlined"
                              type='text'
                              error={errors.nomeSocial ? true : false}
                           />

                           <FormControl >
                              <InputLabel>{t('genero')}</InputLabel>
                              <input {...register('genero', { required: false })} hidden />
                              <Select
                                 // value={sexo}
                                 label={t('genero')}
                                 // onChange={handleSexo}
                                 // onChange={(e: any) => setSexo(e.target.value), (e: any) => setValue('sexo', e.target.value)}
                                 onChange={handleGenero}
                                 MenuProps={{ PaperProps: { sx: { maxHeight: 450 } } }}
                              >
                                 <MenuItem value="Homem">Homem</MenuItem>
                                 <MenuItem value="Mulher">Mulher</MenuItem>
                                 <MenuItem value="Outros">Outros</MenuItem>
                              </Select>
                           </FormControl>

                        </div>

                        <div className={styles.grid} hidden={! hasOtherGenre}>

                           <FormControl >
                              <TextField
                                 {...register('outroGenero')}
                                 label={t('outroGenero')}
                                 variant="outlined"
                                 type='text'
                                 error={errors.outroGenero ? true : false}
                              //helperText={errors.telefoneRequerente && 'Campo Telefone está vazio!'}
                              />
                           </FormControl>

                        </div>

                        <div className={styles.grid}>
                           
                           <TextField
                              {...register('telefone', { required: false })}
                              label={t('telefone')}
                              variant="outlined"
                              type='text'
                              onChange={handleTelefoneMascara}
                              error={errors.telefone ? true : false}
                           //helperText={errors.telefoneRequerente && 'Campo Telefone está vazio!'}
                           />
                           <TextField
                              {...register('email', { required: false })}
                              label={t('email')}
                              variant="outlined"
                              type='text'
                              error={errors.email ? true : false}
                           //helperText={errors.emailRequerente && 'Campo E-mail esta vazio!'}
                           />

                        </div>

                        <div className={styles.grid}>

                        <FormControl error={errors.estadoMembro ? true : false}>
                              <InputLabel>{t('estadoMembro')}</InputLabel>
                              <input {...register('estadoMembro', { required: false })} hidden />
                              <Select
                                 value={estadoMembro}
                                 label={t('estadoMembro')}
                                 onChange={handleChangeEstadoMembro}
                                 MenuProps={{ PaperProps: { sx: { maxHeight: 450 } } }}
                              >
                                 {!!estadoMembroList ?
                                    estadoMembroList.map((option: any, i: any) =>
                                       <MenuItem value={option.nome} key={i} >{option.nome}</MenuItem>
                                    )
                                    :
                                    <MenuItem value={0}>Nada a ser exibido</MenuItem>
                                 }
                              </Select>
                        </FormControl>

                           <FormControl error={errors.estadoUsuario ? true : false}>
                              <InputLabel>{t('estadoUsuario')}</InputLabel>
                              <input {...register('estadoUsuario', { required: false })} hidden />
                              <Select
                                 value={estadoUsuario}
                                 label={t('estadoUsuario')}
                                 onChange={handleChangeEstadoUsuario}
                                 MenuProps={{ PaperProps: { sx: { maxHeight: 450 } } }}
                                 disabled={isDisabled}
                              >
                                 {!!estadoUsuarioList ?
                                    estadoUsuarioList.map((option: any, i: any) =>
                                       <MenuItem value={option.id} key={i} >{option.nome}</MenuItem>
                                    )
                                    :
                                    <MenuItem value={0}>Nada a ser exibido</MenuItem>
                                 }
                              </Select>
                              {/* {errors.estado &&
                                 <FormHelperText>{errors.estado.message?.toString()}</FormHelperText>
                              } */}
                           </FormControl>

                        </div>

                        <div className={styles.grid}>

                           <FormControl>
                              <InputLabel>{t('cidadeUsuario')}</InputLabel>
                              <input {...register('cidadeUsuario', { required: false })} hidden />
                              <Select
                                 value={cidadeUsuario}
                                 label={t('cidadeUsuario')}
                                 onChange={handleChangeCidadeUsuario}
                                 MenuProps={{ PaperProps: { sx: { maxHeight: 450 } } }}
                                 disabled={isDisabled}
                              >
                                 {!!cidadeUsuarioList ?
                                    cidadeUsuarioList.map((option: any, i: any) =>
                                       <MenuItem value={option.id} key={i}>{option.nome}</MenuItem>
                                    )
                                    :
                                    <MenuItem value={0}>Nada a ser exibido</MenuItem>
                                 }
                              </Select>
                           </FormControl>

                           <TextField
                              {...register('endereco', { required: false })}
                              label={t('endereco')}
                              variant="outlined"
                              type='text'
                              error={errors.endereco ? true : false}
                           //helperText={errors.cepRequerente && 'Campo Endereço está vazio!'}
                           />
                        </div>

                        <Typography>
                           <span className={styles.formDescription}>
                              {t('tituloDescricaoFato')}
                           </span>
                        </Typography>

                        <div>
                           <FormControl error={errors.grupoTrabalho ? true : false}>
                              <FormLabel>
                                 {t('textoTema')}
                              </FormLabel>

                              <div className='col'>
                                 {grupoTrabalhoList.length > 0 &&
                                    <>
                                       {grupoTrabalhoList.map((e: any, i: any) => (
                                          <div key={i}>
                                             <FormControlLabel
                                                {...register(`grupoTrabalho`, { required: true })}
                                                control={<Checkbox
                                                   style={{ color: errors.grupoTrabalho ? 'red' : '' }}
                                                   value={[e.idGrupoTrabalho, e.atividade]}
                                                   onChange={handleCheckBox}
                                                />}
                                                label={''}
                                             />
                                             {<span style={{ color: errors.grupoTrabalho ? 'red' : '' }}>
                                              {t(e.atividade)}
                                             </span>
                                             }
                                          </div>
                                       ))}

                                       {(grupoTrabalhoOutros) &&
                                          <TextField
                                             {...register('grupoTrabalhoOutros', { required: true })}
                                             label={t('grupoTrabalhoOutros')}
                                             variant="outlined"
                                             type='text'
                                             error={errors.grupoTrabalhoOutros ? true : false}
                                             helperText={errors.grupoTrabalhoOutros && "Campo de outros esta vazio!"}
                                          />
                                       }
                                       {errors.grupoTrabalho &&
                                          <FormHelperText>{errors.grupoTrabalho.message?.toString()}</FormHelperText>
                                       }
                                    </>
                                 }
                              </div>
                           </FormControl>

                        </div>

                        <div className={styles.grid}>
                           <TextField
                              {...register('dataViolacao', { required: false })}
                              label={t('dataViolacao')}
                              type="date"
                              onBlur={handleVerificaData}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ min: `${anoAtual}-01-01`, max: '9999-12-31' }}
                              error={errors.dataViolacao ? true : false}
                              helperText={errors.dataViolacao && errors.dataViolacao.message?.toString()}
                           />
                        </div>
                        <div>
                           <TextField
                              {...register('fato', { required: true })}
                              label={t('fato')}
                              placeholder={t('fato')}
                              variant="outlined"
                              type='text'
                              multiline rows={7}
                              inputProps={{ maxLength: 2000 }}
                              onChange={(e) => {
                                 setValue('fato', e.target.value);
                                 setFatoLength(e.target.value.length);
                               }}
                              error={errors.fato ? true : false}
                           //helperText={errors.situacaoDescrita && 'Campo de Descreva resumidamente os fatos está vazio!'}
                           />
                           <p className={styles.contador}>{t('textoCaracteresRestantes')} {2000 - fatoLength}</p>
                        </div>
                        <div>
                           <TextField
                              {...register('pedido', { required: true })}
                              label={t('pedido')}
                              placeholder={t('placeholderPedido')}
                              variant="outlined"
                              type='text'
                              multiline rows={7}
                              inputProps={{ maxLength: 500 }}
                              onChange={(e) => {
                                 setValue('pedido', e.target.value);
                                 setPedidoLength(e.target.value.length);
                               }}
                              error={errors.pedido ? true : false}
                           //helperText={errors.solicitacaoDescrita && 'Campo de Descreva resumidamente o que você está solicitando está vazio!'}
                           />
                           <p className={styles.contador}>{t('textoCaracteresRestantes')} {500 - pedidoLength}</p>
                        </div>
                        <div className={styles.grid}>
                           <FormControl >
                              <InputLabel>{t('estadoOcorrencia')}</InputLabel>
                              <input {...register('estadoOcorrencia', { required: false })} hidden />
                              <Select
                                 value={estadoOcorrencia}
                                 label={t('estadoOcorrencia')}
                                 onChange={handleChangeEstadoOcorrencia}
                                 MenuProps={{ PaperProps: { sx: { maxHeight: 450 } } }}
                              >
                                 {!!estadoOcorrenciaList ?
                                    estadoOcorrenciaList.map((option: any, i: any) =>
                                       <MenuItem value={option.id} key={i} >{option.nome}</MenuItem>
                                    )
                                    :
                                    <MenuItem value={0}>{t('textoNaoTemDados')}</MenuItem>
                                 }
                              </Select>
                           </FormControl>
                           <FormControl>
                              <InputLabel>{t('cidadeOcorrencia')}</InputLabel>
                              <input {...register('cidadeOcorrencia', { required: false })} hidden />
                              <Select
                                 value={cidadeOcorrencia}
                                 label={t('cidadeOcorrencia')}
                                 onChange={handleChangeCidadeOcorrencia}
                                 MenuProps={{ PaperProps: { sx: { maxHeight: 450 } } }}
                              >
                                 {!!cidadeOcorrenciaList ?
                                    cidadeOcorrenciaList.map((option: any, i: any) =>
                                       <MenuItem value={option.id} key={i}>{option.nome}</MenuItem>
                                    )
                                    :
                                    <MenuItem value={0}>{t('textoNaoTemDados')}</MenuItem>
                                 }
                              </Select>
                           </FormControl>
                        </div>
                        <div>
                           <TextField
                              {...register('contatoEnvolvido', { required: false })}
                              label={t('contatoEnvolvido')}
                              variant="outlined"
                              type='text'
                              autoComplete='off'
                              error={errors.contatoEnvolvido ? true : false}
                           />
                        </div>
                        <div className={styles.sectionFiles}>
                           <div className={styles.cardFiles}>
                              <div className={styles.contentLabel}>
                                 <p>{t('textoMaximoArquivo')}</p>
                                 <p>{t('textoTipoArquivo')}</p>
                                 <label htmlFor="peticaoFiles" onChange={saveSelectedFiles} className={`${isDisabled && styles.isDisabled}`}>
                                    {t('textoAnexarArquivos')}
                                    <input
                                       name="peticaoFiles"
                                       id="peticaoFiles"
                                       type="file"
                                       multiple
                                       hidden
                                    />
                                 </label>
                              </div>


                              <div>
                                 {selectedFiles.length > 0 &&
                                    <>
                                       <hr />
                                       {selectedFiles.map((file, index) => (
                                          <div key={index} className={styles.savedFiles}>
                                             <div className={styles.fileName}>{file.name}</div>
                                             <div>
                                                {
                                                   file.sizeInMb > 10 ?
                                                      <span className={styles.sizeError}>{file.sizeInMb.toFixed(3)}mb (máx 10mb)</span>
                                                      :
                                                      <span>{file.sizeInMb.toFixed(3)}mb (máx 10mb)</span>
                                                }
                                                <span className={styles.buttonRemoveImage} onClick={() => removeSelectedFile(index)} title="Remover imagem">
                                                   <RemoveCircleIcon sx={{ fontSize: 30, color: '#1464BF' }} />
                                                </span>
                                             </div>
                                          </div>
                                       ))}
                                    </>
                                 }
                              </div>
                              {errorMsg && <p className={styles.sizeError}>{t('msgImgExcedemQuantidade')}</p>}
                           </div>
                        </div>

                        <Typography>
                           <FormControlLabel
                              control={
                                 <Checkbox
                                    checked={isCheckboxChecked}
                                    onChange={handleCheckboxChange}
                                 />
                              }
                              label={t('textoTermo')}
                              style={{ textAlign: 'justify' }}
                           />
                        </Typography>

                        <div className={styles.formButton}>
                           <Button variant="contained" type='submit' disabled={!isCheckboxChecked}>
                              {t('buttomAbrirPeticao')}
                           </Button>
                        </div>

                        <div>
                           <p className={styles.avisoInformacao}>
                              {t('textoAvisoInformacao')} &nbsp;
                              <Link to="https://www.dpu.def.br/fale-conosco" target="_blank">
                                 {t('linkCliqueAqui')}
                              </Link>
                           </p>                           
                        </div>

                     </form>
                  </CardContent>
               </Card>
            </div>
         </div>
         <Modal isOpen={openModal} setOpenModal={setOpenModal} title='Petição registrada!'
            body={<span>
               <span dangerouslySetInnerHTML={{ __html: textoRegistroDenuncia }}></span>
               <Tooltip title='Copiar numero do registro da petição'>
                  <ClipboardText size={28} color='#030303' weight='duotone' onClick={copyToClipboard} />
               </Tooltip>
            </span>}
         />

         <ProgressoCircular open={isOpenProgressoCircular} />

      </section>
   )
}
